import React from 'react';

import { Button } from '@capintel/component-lib/button';
import { SearchInput } from '@/views/components/inputs';

import { FormattedMessage, formatMessage } from '@/utils/i18n';
import { truncateString } from '@/utils/objects';

import { CurrentContact } from '@/redux/modules/types/contacts';

interface ContactDetailsRiskProfilesHeaderProps {
  currentContact: CurrentContact;
  loading: boolean;
  searching: boolean;
  query: string;
  onSearch: (query: string) => void;
  onCreateRiskProfile: () => void;
}

export const ContactDetailsRiskProfilesHeader: React.FC<ContactDetailsRiskProfilesHeaderProps> = ({
  currentContact,
  loading,
  searching,
  query,
  onSearch,
  onCreateRiskProfile,
}) => {
  const hasRiskProfiles = !!currentContact?.contact.riskProfiles?.length;

  return (
    <div className="contact-details-risk-profiles-header">
      <h3 className="contact-details-comparisons-header-title">
        <FormattedMessage
          data-private
          data-dd-privacy="mask"
          id="Contacts.ContactTabs.RiskProfiles.Header"
          values={{ name: truncateString(currentContact?.contact?.fname ?? '', 80) }}
        />
      </h3>

      {hasRiskProfiles && (
        <div className="content-actions">
          <SearchInput
            className="search-input-v2"
            loading={searching}
            placeholder={formatMessage('Contacts.ContactTabs.RiskProfiles.SearchPlaceholder')}
            value={query}
            onChange={onSearch}
          />
          <Button variant="primary" disabled={loading} icon="add" onClick={() => onCreateRiskProfile()}>
            <FormattedMessage id="RiskProfilesTable.AddARiskProfile" />
          </Button>
        </div>
      )}
    </div>
  );
};
